import { Injectable } from '@angular/core';
import {session} from '../../../environments/environment.session'
import { Utf8EncodingService } from './utf8-encoding.service';
@Injectable({
  providedIn: 'root'
})
export class EditorService {

  ebillUser;
  b_acct_id;
  current_date;
  to_data:any = {};
  language = 'English'
  class_hindi:boolean=false;
  header:any;
  footer:any;
  body:any;


  clearTetx = async () => {
    if(this.body){
      this.header.nativeElement.innerHTML =" "
      this.body.nativeElement.innerHTML=" "
      this.footer.nativeElement.innerHTML =" "
      this.to_data = {}

    }

  }

  constructor(private utf8EncodingService:Utf8EncodingService) {
    this.ebillUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    this.current_date = mm + '/' + dd + '/' + yyyy;

  }
}
